import { RetailerContactInfo, RetailerPolicyLinks } from './componets';
import { useParameters } from '@web/utils';
import { env } from '@/env';
import { Retailer } from '@/types';
import { useRetailerQuery } from '../RetailerPage/retailer.generated';

interface RetailerHomePageParams {
  retailerId: string;
}

export const Spinner = () => {
  return (
    <div
      className="w-full pt-5-0 px-1-6 border-l border-secondary-grey relative"
      data-testid="spinner"
    >
      <div className="absolute right-50-percent bottom-50-percent  transform translate-x-50-percent translate-y-50-percent ">
        <div className="border-t-transparent border-solid animate-spin rounded-full border-primary-yellow border-4 h-5-0 w-5-0"></div>
      </div>
    </div>
  );
};
const RetailerHomePage: React.FC = () => {
  const { retailerId } = useParameters<RetailerHomePageParams>();

  const [{ data, fetching }] = useRetailerQuery({
    variables: {
      retailerId,
    },
  });

  return (
    <div className="py-4-0">
      {fetching && <Spinner />}
      {data && data?.retailer && (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-6-0">
            <div>
              <img
                src={`${env.VITE_STATIC_URL}/retailer/images/${retailerId}-banner.png`}
                className="rounded-8-0 w-full"
              />
              <div className="w-full text-primary-black flex items-center py-2-0">
                <div>
                  <h1 className="font-bold text-2-4 mb-2-0">
                    {data.retailer.name}
                  </h1>
                  <p className="text-1-4 font-rg leading-1-94">
                    {data.retailer.description}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <RetailerContactInfo retailer={data.retailer as Retailer} />
              <RetailerPolicyLinks
                className="my-2-0"
                retailer={data.retailer as Retailer}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RetailerHomePage;
